import { render } from "./LicensesComponent.vue?vue&type=template&id=30647ac6"
import script from "./LicensesComponent.vue?vue&type=script&lang=js"
export * from "./LicensesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__